import React, { Component } from 'react';
import { BotBubbleSvg } from '../utils/svg-icons-24';

class Loader extends Component{
    // constructor(props){
    //     super(props);
    // }
    render(){
        const { botTitle } = this.props;
        return(
            <div className="message message-operator typing-indicator loading">
                <i className="conv-icon">
                    <BotBubbleSvg />
                    <span>{botTitle}</span>
                </i>
                <span className="message-content"></span>
                <span className="message-content"></span>
                <span className="message-content"></span>
            </div>        
        )
    }
}
// Loader.propTypes = {
//     className: React.propTypes.node,
// }
export default Loader;